import { Route } from '@angular/router';
import { AppUrls } from '../../../../common/dto/app-urls';
import { HasCompanyRouteGuard, LoggedInRouteGuard, ValidatedEmailRouteGuard } from '../common/routing/route-guards/session-check.guard';
import { AnnounceRoute } from './announce/announce.routes';
import { CompanyRoute } from './company/company.routes';
import { DashboardComponent } from './dashboard.component';
import { DiscoverRoute } from './discover/discover.routes';
import { FeedbackRoute } from './feedback/feedback.routes';
import { GuideRoute } from './guide/guide.routes';
import { HelpRoute } from './help/help.routes';

export const DashboardRoute: Route = {
  path: AppUrls.Dashboard.relativeUrl,
  canActivate: [
    LoggedInRouteGuard,
    ValidatedEmailRouteGuard,
    HasCompanyRouteGuard,
  ],
  children: [
    {
      path: AppUrls.Dashboard._.Home.relativeUrl,
      component: DashboardComponent,
      children: [
        {
          path: AppUrls.Dashboard._.Home.relativeUrl,
          loadComponent: () => import('./home/home.component').then(_ => _.HomeComponent),
        },
        HelpRoute,
        CompanyRoute,
        GuideRoute,
        AnnounceRoute,
        DiscoverRoute,
        FeedbackRoute,
        {
          path: AppUrls.Dashboard._.NotFound.relativeUrl,
          loadComponent: () => import('../common/components/not-found/not-found.component').then(_ => _.NotFoundComponent),
        },
        {
          path: '**',
          redirectTo: AppUrls.Dashboard._.Home.relativeUrl,
        },
      ],
    },
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Home.relativeUrl,
    },
  ],
};
